module.exports = __webpack_public_path__ + "img/burton.86868c1d.svg";